import {ICreateLeadImplant} from '../reducers/LeadImplantReducers';

export function createLeadImplant(data: ICreateLeadImplant, resolve: any, reject: any) {
  console.log(`action createLeadImplant with data ${JSON.stringify(data)}`)
  return {
    type: 'ADD_LEAD_IMPLANT',
    data,
    reject,
    resolve,
  }
}
